import React, { useEffect, useRef, useState } from 'react';

import * as api  from './api';

import {Button,Icon,Input} from 'semantic-ui-react';

import {gaEvent} from './ga-event';

import {Clues} from './Clues';

import {checkAnswerComponent,getPuzzleData,findContainingPatternsForCellClickedComponent,getPatternInputComponent} from './puzzle-service';

import {onInputComponent,onKeyDownComponent,onKeyUpComponent,getCellRefComponent,
    focusCellComponent,patternClickComponent,onListPatternClickComponent,
    onCellClickComponent,addtoFoundPatternsComponent,findFirstEnabledCellComponent} from './puzzle-service/puzzle-interaction';

import {findFilledPatterns,getRestoredCellVals} from './puzzle-service/restore-answers';

import {handleResizeComponent} from './puzzle-service/handle-resize';

import {findPatternCells} from './puzzle-service/common';
import {getAnswers} from './puzzle-service/patterns-with-fill-info';

import {GetNewPuzzle} from './GetNewPuzzle';
import {copyTextToClipboard} from './puzzle-service/utils';
import {patternsFoundSingleton} from './puzzle-service/patterns-found-singleton';
import {onPuzzleHintClickComponent} from './puzzle-service/puzzle-hint';

export const Puzzle = ({getNewPuzzleHandler,rows=16,cols=16})=>{

    const [puzzleDetail,setPuzzleDetail] = useState();
       

    const [patternCells,setPatternCells] = useState({});
    const [selectedPattern,setSelectedPattern] = useState();
    
    const [lastCellInputs,setLastCellInputs] = useState([]);

    
    const [activeTab,setActiveTab] = useState(0);

    const [foundPatternCells,setFoundPatternCells]=useState({});
    const [foundPatterns,setFoundPatterns] = useState([]);
   
    const [cellVals,setCellVals] = useState({});

    const [showGetNewPuzzle,setShowGetNewPuzzle] = useState(false);

    const [puzzleSkipped,setPuzzleSkipped] = useState(false);

    const [cellWidth,setCellWidth] = useState(0);

    const [scrollVisible,setScrollVisible] = useState(false);
    const [selectedPatternInput,setSelectedPatternInput] = useState('');
    const [isVerticalScreen,setIsVerticalScreen] = useState(false);
    const [hintCheckVisible,setHintCheckVisible] = useState(true);
    
   /*  const [puzzleGameContainerStyle,setPuzzleGameContainerStyle] = useState({width:'100%'}); */

   /*  const [showHamburger,setShowHamburger] = useState(false);
    const [currentIndex,setCurrentIndex] = useState(0); */
    
   

    let cellRefs = useRef([]);
    const [cellRefsMap,setCellRefsMap] = useState({});
    let puzzleGrid = React.createRef();
    let puzzleContainer = React.createRef();
    let puzzleGameContainer = React.createRef();


    const handleResize = handleResizeComponent(puzzleGrid,setCellWidth,rows,cols,scrollVisible,isVerticalScreen);

    useEffect(()=>{   
        
        const checkVertical=()=>{

            const {clientWidth,clientHeight} = document.body;

            //const vertical =clientHeight > clientWidth;

            const vertical = clientHeight / clientWidth > 3/4;

            if(isVerticalScreen!==vertical){
                //console.log('vertical test',document.body.clientHeight, document.body.clientWidth);
                setIsVerticalScreen(vertical);
            }            
            
        };
        
        const onResize = ()=>{
            checkVertical();
        };

        window.addEventListener('resize',onResize );

        checkVertical();

        return ()=>{
            window.removeEventListener('resize',onResize);
        };

    },[isVerticalScreen]);

    useEffect(()=>{

        if(isVerticalScreen){
            //console.log('is vertical screen');
            if(puzzleGameContainer.current){
                puzzleGameContainer.current.style.height = '100vh';
            }
            
        }else{
            if(puzzleGameContainer.current && 
                (!puzzleGameContainer.current.style.height || puzzleGameContainer.current.style.height === '100vh')
                ){
                puzzleGameContainer.current.style.height = `${document.body.clientHeight}px`;
                puzzleGameContainer.current.style.overflow = 'auto';
            }
        }

    },[isVerticalScreen,puzzleGameContainer,puzzleGrid,cellWidth]);

    useEffect(()=>{
        const setWidthOfPuzzleRows = ()=>{
            if(puzzleGrid && puzzleGrid.current){
                for (let row of puzzleGrid.current.children){
                    //console.log(row);
                    row.style.width = `${cellWidth * cols}px`;
                }

            
            }
        }
        setWidthOfPuzzleRows();
    },[cellWidth,puzzleGrid,cols]);
   
    useEffect(()=>{
        const isScrollVisible = ()=>{

            if(!puzzleContainer || !puzzleContainer.current) return false;


            const result = puzzleContainer.current.scrollHeight > puzzleContainer.current.offsetHeight;

            //console.log('is scroll visible',result, puzzleContainer.current.scrollHeight, puzzleContainer.current.offsetHeight);

            return result;
        };              
        
        const interval = setInterval(()=>{
            const isVisible = isScrollVisible();

            if(scrollVisible!==isVisible){
                setScrollVisible(isVisible);
            }
            
        },200);

        return ()=>{
            clearInterval(interval);
        };

    },[puzzleContainer,scrollVisible]);

   /*  useEffect(()=>{
        const style = scrollVisible && puzzleGameContainer.current ? 
            {width:`${puzzleGameContainer.current.clientWidth - 120}px`} : {width:'100%'};
        
        setPuzzleGameContainerStyle(style);

    },[scrollVisible,puzzleGameContainer]); */
      
    useEffect(()=>{
        
        const createAllCellRefs = (grid)=>{
            let index = 1;
            
            const cellRefsMap = {};

            for(let r=0;r<grid.length;r++){
                for (let c=0;c<grid[r].length;c++){
                    cellRefs.current[index] = React.createRef();
                    cellRefsMap[`${r}_${c}`] = index;
                    index++; 
                }
            }

            setCellRefsMap(cellRefsMap);           
           
        };
        
        (async ()=>{

            /* const dimensions = await api.getAvailablePuzzleDimensions();

            console.log('dimensions',dimensions); */

            const puzzle = await api.getRandomPuzzle(rows,cols);
            //console.log('puzzle',puzzle.puzzle);
            //console.log('puzzleId',puzzle.puzzle.puzzleId);

            if(!puzzle.puzzle.puzzleId) return;

            setPuzzleDetail(puzzle);
            initCellVals(puzzle.puzzle.grid);
            //restoreCellVals();

            createAllCellRefs(puzzle.puzzle.grid);
            
        })();

    },[rows,cols]);

    
    
    useEffect(()=>{     
               
        handleResize();
        
    },[handleResize]);

    useEffect(() => {
       
        window.addEventListener('resize', handleResize)
    
        return () => {
          window.removeEventListener('resize', handleResize)
        }
      }, [handleResize]);

    useEffect(()=>{
        if(!puzzleDetail) return;
        //console.log(`patterns:${puzzleDetail.puzzle.patterns.length}, found patterns: ${foundPatterns.length}`);
    },[puzzleDetail,foundPatterns]);

    
    useEffect(()=>
    {
        (async()=>{

            if (!puzzleDetail || !puzzleDetail.puzzle) return;
            
            const cellVals = getRestoredCellVals(puzzleDetail);

            if (Object.keys(cellVals).length > 0) {
              const filledPatternsFound = await findFilledPatterns(
                puzzleDetail,
                cellVals
              );

              const patterns = filledPatternsFound.map(p=>p.pattern);              

              setFoundPatterns(patterns);

              patternsFoundSingleton.addMany(patterns);              

              let newFoundPatternCells = {};

              for(let pattern of patterns){

                const patternsCells = findPatternCells(pattern);

                newFoundPatternCells = {...newFoundPatternCells,...patternsCells};

              }              

              setFoundPatternCells(newFoundPatternCells);          
              
              setCellVals(cellVals);

            }

        })();        


    },[puzzleDetail]); 

    useEffect(()=>{
        //console.log('found patterns count:',foundPatterns.length);
       
    },[foundPatterns]);

    useEffect(()=>{
        //console.log('puzzle skipped',puzzleSkipped);
        if(puzzleSkipped){
            setShowGetNewPuzzle(true);
        }
    },[puzzleSkipped]);

   /*  useEffect(()=>{
        const checkShowHamburger = ()=>{
            //console.log('container widths',puzzleContainer,puzzleGameContainer);
            if(puzzleGameContainer && puzzleGameContainer.current){
                return puzzleGameContainer.current.clientWidth - cellWidth * cols < 60;
            }else{
                return false;
            }
        }

        setShowHamburger(checkShowHamburger());

    },[puzzleGameContainer,cellWidth]); */

   
    const initCellVals = (grid)=>{
        
        const result = {};

        for(let r=0;r<grid.length;r++){
            const row = grid[r];
            for(let c=0;c<row.length;c++){
                result[`${r}_${c}`] = row[c];
            }
        }

        setCellVals(result);
    };
    

    const saveCellVals = (cellVals)=>{
        localStorage.setItem(`puzzle_${puzzleDetail.puzzle.puzzleId}`,JSON.stringify(cellVals,null,2));
    }

    const setCell = (row,col,value)=>{
        const cellValsCopy = {...cellVals};
        cellValsCopy[`${row}_${col}`] = value;
        //console.log('cellVals',cellValsCopy);
        saveCellVals(cellValsCopy);
        setCellVals(cellValsCopy);
        setLastCellInputs([{row,col}]);
        
    }

    
    let findContainingPatternsForCellClicked = null;
    let addToFoundPatterns = null;
    let checkAnswer = null;
    let getPatternInput = null;
    

    useEffect(() => {
      const processCellInput = async (lastCellInputs) => {
        const patterns = [];

        if (!addToFoundPatterns) return;


        for (let lastCellInput of lastCellInputs) {
          const { row, col } = lastCellInput;

          //console.log('last cell input',row,col);

          //if(!findContainingPatternsForCellClicked) return;
          
          const checkResult = await checkAnswer(row, col);

          const wordFound =
            (checkResult.horizontal &&
              checkResult.horizontal.checkResult.isCorrect) ||
            (checkResult.vertical &&
              checkResult.vertical.checkResult.isCorrect);

          if (wordFound) {
            //console.log('check-result',checkResult);

            if (checkResult.horizontal) {

              const exists = patterns.some(p=>p === checkResult.horizontal.pattern );

              if(!exists) patterns.push(checkResult.horizontal.pattern);
              //addToFoundPatterns(checkResult.horizontal.pattern);
            }

            if (checkResult.vertical) {
              const exists = patterns.some(p=>p === checkResult.vertical.pattern );
              if(!exists) patterns.push(checkResult.vertical.pattern);
              //addToFoundPatterns(checkResult.vertical.pattern);
            }

            //console.log('found pattern cells',foundPatternCells);
          }
        }

        addToFoundPatterns(patterns);
      };

      (async () => {
        if (lastCellInputs) {
          await processCellInput(lastCellInputs);
        }
      })();
    }, [lastCellInputs, checkAnswer, addToFoundPatterns]);


    useEffect(()=>{

        const getSelectedPatternInput = ()=>{
            return selectedPattern ? getPatternInput(selectedPattern) : '';
        } 

        setSelectedPatternInput(getSelectedPatternInput());
        //console.log('selected pattern input',selectedPatternInput);
    },[cellVals,selectedPattern,getPatternInput,selectedPatternInput]);
   

    if(!puzzleDetail || !puzzleDetail.puzzle) return null;
    //console.log(puzzleDetail);

    const {grid,horizontalPatterns,verticalPatterns,patterns} = getPuzzleData(puzzleDetail);      
   
    const onPatternClick = patternClickComponent({setPatternCells,setSelectedPattern,setActiveTab});
    
    const getCellRef = getCellRefComponent({cellRefsMap,cellRefs});

    const focusCell = focusCellComponent({getCellRef});

    const findFirstEnabledCell = findFirstEnabledCellComponent({findPatternCells,getCellRef});

    const onListPatternClick = onListPatternClickComponent({findFirstEnabledCell,onPatternClick,focusCell});
    
    findContainingPatternsForCellClicked = findContainingPatternsForCellClickedComponent({horizontalPatterns,verticalPatterns});
        

    const onKeyDown = onKeyDownComponent({findFirstEnabledCell,setCell,getCellRef,focusCell,selectedPattern});
    const onKeyUp = onKeyUpComponent({findFirstEnabledCell,findContainingPatternsForCellClicked,onPatternClick,focusCell}); 
    //const onKeyPress = onKeyPressComponent({setCell,focusCell,selectedPattern});
    const onInput = onInputComponent({findFirstEnabledCell,getCellRef,setCell,focusCell,selectedPattern});

    const onCellClick = onCellClickComponent({findContainingPatternsForCellClicked,onPatternClick,selectedPattern});

    addToFoundPatterns = addtoFoundPatternsComponent({foundPatternCells,setFoundPatternCells,foundPatterns,setFoundPatterns});

    checkAnswer = checkAnswerComponent({puzzleDetail,cellVals,findContainingPatternsForCellClicked,
        foundPatternCells,foundPatterns,setFoundPatternCells,setFoundPatterns});

    getPatternInput = getPatternInputComponent(cellVals);

    const onPuzzleHintClick = onPuzzleHintClickComponent(puzzleDetail,selectedPattern,setHintCheckVisible,saveCellVals,cellVals,setCellVals,setLastCellInputs,rows,cols);

    //const findFilledPatterns = findFilledPatternsComponent({patterns,setRestoredPatterns});
    //restoreCellVals = restoreCellValsComponent({puzzleDetail,setCellVals,findFilledPatterns});
  
    // const width = grid[0].length * 32 + 24;


   
   
    const getGridRow = row => {

        
        return grid[row].map((c,i)=>{ 

            const key = `${row}_${i}`;

            const isPatternCell = !!patternCells[key];
            const isFoundPatternCell = !!foundPatternCells[key];

            const getChar =  (c)=>c === '*' ? '' : c.toUpperCase();
            

            const classes = ['puzzle-cell'];
            
            if(c==='*') classes.push('black-cell');
           

            if(isPatternCell && isFoundPatternCell){
                classes.push('selected-found-pattern');
            }
            else{

                if(isPatternCell) classes.push('selected-pattern');
                if(isFoundPatternCell) classes.push('found-pattern');
            } 

            const className = classes.join(' ');                                                  

            let cellChar = cellVals[`${row}_${i}`];
            cellChar = cellChar ? cellChar : '';

            const cellStyle = {
                width:`${cellWidth}px`,
                height:`${cellWidth}px`, 
                lineHeight: `${cellWidth}px` 
                 };
            
            const cellInputStyle = {fontSize: `${Math.floor(cellWidth/2)}px`};
           
            if(cellChar==='*'){
                return (<div key={i} className={className} 
                    style={cellStyle}
                    >{getChar(cellChar)}</div>);
            }else{


                return (
                    <div key={i} className={className} style={cellStyle} onClick={()=>{onCellClick(row,i);}}>
                        <input ref={getCellRef(row,i)} maxLength="1" className="puzzle-cell-input"
                        style={cellInputStyle} 
                        disabled={isFoundPatternCell}
                                                 
                         
                        value={getChar(cellChar)}
                        onChange={(e)=>{setCell(row,i,e.target.value);}}
                        onKeyDown ={(e)=>{onKeyDown(e,e.code,e.key,row,i)}}
                        onKeyUp={(e)=>{
                            //console.log(e); 
                            onKeyUp(e,e.code,e.key,row,i);}}
                        // onKeyPress={(e)=>{onKeyPress(e,row,i)}}
                        onInput={(e)=>{onInput(e,row,i)}}
                        ></input>
                        
                    </div>
                    
                );
            }
            
        })
    };

    

    const getGridRows = ()=>{
        return grid.map((r,i)=>{return <div className="puzzle-row" key={i}>{getGridRow(i)}</div>});
    };

   
    

    //height:`${cluesHeight}px`

    const isPuzzleComplete = foundPatterns.length === patterns.length;

    const onGetNewPuzzleClick = async ()=>{
        setShowGetNewPuzzle(true);
    };
 
    const onGetPuzzle = async (rows,cols)=>{
        setShowGetNewPuzzle(false);
        console.log(`on get puzzle: ${rows}x${cols}`);
        
        //const patternsWithFillInfo = getPatternsWithFillInfo(foundPatterns,cellVals);
        //console.log('patterns with fill info',cellVals,patternsWithFillInfo);
        //console.log('answers',puzzleDetail.puzzle.puzzleId,puzzleDetail.puzzleUser,getAnswers(foundPatterns,cellVals));
        const puzzle = puzzleDetail.puzzle.puzzleId;
        const user = puzzleDetail.puzzleUser;

        //skipping this puzzle and getting a new one!
        if(puzzleSkipped){
             await api.skipPuzzle(puzzle,user);
             gaEvent.skip({rows,cols});
             if(getNewPuzzleHandler) getNewPuzzleHandler(rows,cols);
             return;
        }

        //completing the puzzle and getting a new one!
        const answers = getAnswers(foundPatterns,cellVals);
        const result = await api.completePuzzle(puzzle,user,answers);

        if(result.success){
            gaEvent.complete({rows,cols});
            if(getNewPuzzleHandler) getNewPuzzleHandler(rows,cols);
        }
        
    };

    const copyPuzzleIdtoClipBoard = ()=>{
        
        if(!puzzleDetail) return;

        //console.log('copy puzzle id to clipboard',puzzleDetail.puzzle.puzzleId);

        copyTextToClipboard(puzzleDetail.puzzle.puzzleId);
    };

    const selectedPatternRegion = 
        selectedPattern ? 
        <div style={scrollVisible ? {paddingTop:'44px'}:null}>
            <p style={scrollVisible ? {width:'100%'}:null} onClick={copyPuzzleIdtoClipBoard} className="selected-pattern-region">{selectedPattern.meaning}</p>
        </div>
         : 
        <div style={{minHeight:'40px'}} ></div>;
    

    const getNewPuzzleRegion = (
        <div className="get-new-puzzle">
            <p>Congratulations! You've completed the puzzle. Do you want to solve another?</p>
            <Button color="green" onClick={onGetNewPuzzleClick}>Get New Puzzle!</Button>
        </div>
    );
    
    
    const onSkipPuzzleClick = async ()=>{
        

        //await api.skipPuzzle(puzzle,user);
        setPuzzleSkipped(true);
        
        //getNewPuzzleHandler(8,8);
    };

    const onGetNewPuzzleClose = ()=>{
        setShowGetNewPuzzle(false);
        if(puzzleSkipped){
            setPuzzleSkipped(false);
        }
    };

    /* const isVisible = (index)=>{
        if(!showHamburger) return true;

        return index === currentIndex;

    }; */

    
    const scrollTop = ()=>{
        puzzleContainer.current.scrollTop = 0;
    };

    const scrollBottom = ()=>{
        puzzleContainer.current.scrollTop = puzzleContainer.current.scrollHeight - puzzleContainer.current.clientHeight; 
    };

    const onSelectedPatternInputChange = (e)=>{
        const input = e.target.value;

        const cellValsCopy = {...cellVals};

        if(selectedPattern.direction === 0){
            for(let i=0;i<selectedPattern.length;i++){
                cellValsCopy[`${selectedPattern.row}_${selectedPattern.col+i}`] = input[i];
            }
        }

        else if(selectedPattern.direction === 1){
            for(let i=0;i<selectedPattern.length;i++){
                cellValsCopy[`${selectedPattern.row+i}_${selectedPattern.col}`] = input[i];
            }
        }

        setCellVals(cellValsCopy);

        //setSelectedPatternInput(input);
        
        //console.log(selectedPatternInput,input);
        
    };
    
   
    return (
      <>
        <div className="puzzle-game-container" ref={puzzleGameContainer}>
           
          <div className="puzzle-game-header">
            <div className="puzzle-game-header-inside">
            {isPuzzleComplete ? getNewPuzzleRegion : null}
            
            <GetNewPuzzle
              open={showGetNewPuzzle}
              onClose={onGetNewPuzzleClose}
              onGetPuzzle={onGetPuzzle}
            ></GetNewPuzzle>

            
            
           
           {selectedPatternRegion}

           {/* {showHamburger ? <img onClick={onSidebarOpen} className="hamburger" src={hamburger}></img> : null} */}

           {isPuzzleComplete ? null : (
              /*  <div  className="skip-puzzle">
              <Button basic color="yellow"  size="large" inverted onClick={onSkipPuzzleClick}>Skip Puzzle</Button>
              </div> */
            <>
                {hintCheckVisible ? <div  className="puzzle-button puzzle-hint" onClick={onPuzzleHintClick}>
                    Get Hint
                </div>: null}              
                <div  className="puzzle-button skip-puzzle" onClick={onSkipPuzzleClick}>
                    Skip Puzzle
                 </div>
              </>
            )}

            </div>
           
          </div>
           

        
          
          {false ? (
            <div className="scroll-buttons">
                <Icon onClick={scrollTop} style={{cursor:'pointer'}} name="arrow alternate circle up" size="big"></Icon>
                <Icon onClick={scrollBottom} style={{cursor:'pointer'}} name="arrow alternate circle down" size="big"></Icon>                
            </div>) : null}
          
           {false ? (
                <div className="mobile-input" style={{width:`${cellWidth * cols}px` }}>
                    <Input style={{width:'100%'}}>
                        <input style={{textTransform:'uppercase'}} 
                                value={selectedPatternInput} onChange={onSelectedPatternInputChange}>
                        </input>
                    </Input>
                </div>) : null} 



          <div className={`puzzle-container ${!isVerticalScreen ? 'puzzle-container-horizontal' : ''}`} ref={puzzleContainer}>
            {/* <div className="sample-div"></div> */}
            {/* {isVisible(0) ? <div ref={puzzleGrid} className="puzzle-border">
                {getGridRows()}
            </div> : null }
 */}
            <div ref={puzzleGrid} className="puzzle-border">
                {getGridRows()}
            </div>

            {/* {isVisible(1) ? <Clues
              horizontalPatterns={horizontalPatterns}
              verticalPatterns={verticalPatterns}
              selectedPattern={selectedPattern}
              onListPatternClick={onListPatternClick}
              cellWidth={cellWidth}
              rows = {rows}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            ></Clues>: null} */} 

            <Clues
              horizontalPatterns={horizontalPatterns}
              verticalPatterns={verticalPatterns}
              selectedPattern={selectedPattern}
              onListPatternClick={onListPatternClick}
              cellWidth={cellWidth}
              rows = {rows}
              cols = {cols}
              scrollVisible = {scrollVisible}
              isVerticalScreen = {isVerticalScreen}
              
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            ></Clues>

            
          </div>
          
        </div>
      </>
    );    
   
    
};

